<template>
  <div class="banner" id="banner">
    <swiper class="swiper" :options="swiperOption" ref="mySwiper" v-if="swiperSlides.length > 1">
      <swiper-slide class="slide" :key="index" v-for="(item,index) in swiperSlides">
        <img :src="item" alt=""/>
      </swiper-slide>

    </swiper>
    <div class="Img" v-for="(item, index) in swiperSlides" :key="index" v-if="swiperSlides.length === 1">
      <img :src="item" style="width: 100%" alt="">
    </div>
    <div class="swiper-prev" v-if="swiperSlides.length > 1">
      <i class="iconfont icon-zuojiantou"></i>
    </div>
    <div class="swiper-next" v-if="swiperSlides.length > 1">
      <i class="iconfont icon-youjiantou"></i>
    </div>
  </div>
</template>
<script>
  export default {
    name: "banner",
    data () {
      return {
        swiperOption: {
          notNextTick: true,
          //循环
          loop: true,
          //设定初始化时slide的索引
          initialSlide: 0,
          //自动播放
          autoplay: 3000,
          // 设置轮播
          effect: 'slide',
          //滑动速度
          speed: 300,
          //滑动方向
          direction: 'horizontal',
          paginationHide: true,
          //小手掌抓取滑动
          // grabCursor : true,
          //滑动之后回调函数
          on: {
            slideChangeTransitionEnd: function () {
              console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            },
          },
          //分页器设置
          pagination: '.swiper-pagination',
          paginationClickable: true,
          nextButton: '.swiper-next',
          prevButton: '.swiper-prev'
        },
      }
    },
    props: {
      swiperSlides: {
        type: Array
      },
      status: {
        type: String
      }
    },
    watch: {
      swiperSlides (val) {
        console.log(val.length);
        if (val.length > 1) {


        } else {

        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .banner
    width 100%
    height 100%
    position relative
    .swiper
      width 100%
      height 100%
      position relative
      .slide
        width 100%
        height 100%
        img
          width 100%
    .swiper-pagination
      position absolute
      bottom 40px
      left 0
      width 100%
      margin auto
      z-index 9
    .swiper-next
      width 70px
      height 70px
      text-align center
      line-height 70px
      border-radius 50%
      position absolute
      top 48%
      right 40px
      z-index 99
      cursor pointer
      i
        font-size 35px
      .icon-youjiantou
        color #ffffff
        margin-left 5px
      &:hover
        background rgba(255,255,255,.5)
        .icon-youjiantou
          color #548edf
    .swiper-prev
      width 70px
      height 70px
      text-align center
      line-height 70px
      border-radius 50%
      position absolute
      top 48%
      left 40px
      z-index 99
      cursor pointer
      i
        font-size 35px
      .icon-zuojiantou
        color #ffffff
        margin-right 5px
      &:hover
        background rgba(255,255,255,.5)
        .icon-zuojiantou
          color #548edf
</style>



// WEBPACK FOOTER //
// src/components/public/banner.vue